/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfAdditionalServiceDto } from '../../models/paginated-dto-of-additional-service-dto';

export interface GetAdditionalServices$Params {
  ids: Array<string>;
}

export function getAdditionalServices(http: HttpClient, rootUrl: string, params: GetAdditionalServices$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfAdditionalServiceDto>> {
  const rb = new RequestBuilder(rootUrl, getAdditionalServices.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfAdditionalServiceDto>;
    })
  );
}

getAdditionalServices.PATH = '/api/v1/additional-services';
